export const PACKAGE_NAME = 'jiraAdminPagesPriorities';
export const SOURCE_NAME = 'adminPrioritiesPage';
export const TEAM = 'Yamato';
export const PRIORITY_NAME_FIELD = 'name';
export const PRIORITY_NAME_MAX_LENGTH = 60;
export const PRIORITY_DESC_FIELD = 'description';
export const PRIORITY_DESCRIPTION_MAX_LENGTH = 255;
export const PRIORITY_ICON_FIELD = 'avatarId';
export const PRIORITY_STATUS_COLOR_FIELD = 'statusColor';
export const PAGE_SIZE = 30;

/* Selectors */
export const PRIORITIES_TABLE_REORDER_DROPDOWN_SELECTOR =
	'admin-pages-priorities.ui.priorities-table.reorder.reorder-dropdown';
export const PRIORITIES_MEATBALL_MENU_SELECTOR = 'admin-pages-priorities.ui.dropdown';
export const PRIORITIES_ASSIGN_ALERT_PRIORITIES_DROPDOWN_ITEM_SELECTOR =
	'admin-pages-priorities.ui.assign-alert-priorities';
export const PRIORITIES_TRANSLATE_PRIORITIES_DROPDOWN_ITEM_SELECTOR =
	'admin-pages-priorities.ui.translate-priorities';

export const editPriorityEvent = {
	action: 'edited',
	actionSubject: 'priority',
};

export const createPriorityEvent = {
	action: 'created',
	actionSubject: 'priority',
};

export const deletePriorityEvent = {
	action: 'deleted',
	actionSubject: 'priority',
};

export const reorderPriorityEvent = {
	action: 'reordered',
	actionSubject: 'priority',
};
